export class Financial {
  financial = [];
  completed = false;
  constructor() {
    this.financial = this._initFinancial();
  }

  private _initFinancial() {
    return [
      {
        key: 'savings',
        text: 'My Savings',
        displayData: false,
        iconColor: 'white',
        questionRaws: [
          {
            key: 'myYearlyIncome',
            label: 'My yearly income is',
            order: 1,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 300000 },
              step: 100,
              unit: '$',
              type: 'MY_YEARLY_INCOME_TYPE'
            },
            value: 0,
            icon: 'icon-ic_calculator'
          },
          {
            key: 'savingPercentForYearlyIncome',
            label: 'I save 20% of my yearly income',
            order: 2,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 1 },
              step: 0.01,
              unit: '%',
              type: 'SAVING_YEARLY_INCOME_TYPE',
            },
            value: 0
          },
          {
            key: 'currentSavings',
            label: 'My current savings is',
            order: 3,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 300000 },
              step: 100,
              unit: '$',
              type: 'CURRENT_AVAILABLE_SAVINGS_TYPE',
            },
            value: 0,
            icon: 'icon-ic_calculator'
          },
          {
            key: 'yearRetirement',
            label: 'I wish to retire at',
            order: 4,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 90 },
              step: 1,
              unit: 'age',
              type: 'RETIRE_AT_TYPE'
            },
            value: 60
          },
          {
            key: 'timeReceivedIncome',
            label: 'I wish to receive a retirement income for',
            order: 5,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 60 },
              step: 1,
              unit: 'year',
              type: 'RECEIVE_INCOME_FOR_TYPE',
            },
            value: 0
          },
          {
            key: 'receiveEveryMonth',
            label: 'My monthly retirement income should be',
            order: 6,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 45000 },
              step: 100,
              unit: '$',
              type: 'RECEIVE_EVERY_MONTH_TYPE',
            },
            value: 0,
            icon: 'icon-ic_calculator'
          },
          {
            key: 'myMonthlyExpenses',
            label: 'My monthly lifestyle expenses',
            order: 7,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 15000 },
              step: 100,
              unit: '$',
              type: 'MONTHLY_LIFESTYLE_EXPENSES_TYPE'
            },
            value: 0,
            icon: 'icon-ic_calculator'
          },
          {
            key: 'myFamilyMonthlyExpenses',
            label: 'My family monthly lifestyle expenses',
            order: 8,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 15000 },
              step: 100,
              unit: '$',
              type: 'FAMILY_MONTHLY_LIFESTYLE_EXPENSES_TYPE',
            },
            value: 0,
            icon: 'icon-ic_calculator'
          },
          {
            key: 'yearNotNeedSupport',
            label: 'I will stop supporting my family when I will be',
            order: 9,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 25, max: 100 },
              step: 1,
              unit: 'age',
              type: 'YEAR_NOT_NEED_TO_SUPPORT_FAMILY_TYPE',
            },
            value: 25
          },
        ]
      }];
  }

}



// WEBPACK FOOTER //
// ./src/app/core/models/financial.ts